import { Button, Col, Form, Modal, Row, Table } from "react-bootstrap";
import { meioPagamento } from "./../NFCe.Dto";
import NFCeModalFinalizaCode from "./NFCe.Modal.Finaliza.Code";
import { NFCeModalFinalizarProps } from "./NFCe.Modal.Finalizar.Dto";
import { FloatInput } from "src/componentes";

export const NFCeModalFinalizarView = (props: NFCeModalFinalizarProps) => {
  const code = NFCeModalFinalizaCode(props);

  return (
    <>
      <Modal show={props.show} centered>
        <Modal.Body>
          {!code.podeFinalizar() ? (
            <Form
              id="formPagamento"
              noValidate
              onSubmit={code.form.handleSubmit(code.onSubmitMeioPagamento)}
            >
              {!code.exibirValor ? (
                <Table responsive hover>
                  <thead>
                    <tr>
                      <th className="col-12">Forma pagamento</th>
                    </tr>
                  </thead>
                  <tbody>
                    {meioPagamento.map((item) => (
                      <tr
                        key={item.meioPagamento}
                        onClick={code.handleClickMeioPagamento(item)}
                        style={{ cursor: "pointer" }}
                      >
                        <td className="col-12">{item.descricaoPagamento}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <>
                  <Row>
                    <Col xs={12} className="text-center">
                      <h1>
                        {code.selecionadoMeioPagamento?.descricaoPagamento}
                      </h1>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12}>
                      <FloatInput
                        label="Valor"
                        errorsMessage={
                          code.form.formState.errors.valorPagamento
                        }
                        registerField={code.form.register("valorPagamento")}
                        inputMask="double"
                      />
                    </Col>
                  </Row>
                </>
              )}
            </Form>
          ) : (
            <Form
              id="formDestinatario"
              noValidate
              onSubmit={code.destinatarioForm.handleSubmit(
                code.onSubmitDestinatario
              )}
            >
              <Row>
                <Col xs={12}>
                  <FloatInput
                    label="CPF/CNPJ"
                    errorsMessage={
                      code.destinatarioForm.formState.errors.documento
                    }
                    registerField={code.destinatarioForm.register("documento")}
                    inputMask="cnpj-cpf"
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <FloatInput
                    label="Nome"
                    errorsMessage={code.destinatarioForm.formState.errors.nome}
                    registerField={code.destinatarioForm.register("nome")}
                    inputMask="capitalizar"
                  />
                </Col>
              </Row>
            </Form>
          )}

          <Row>
            <Col>Total: {props.totalNFCe.toFixed(2).replace(".", ",")}</Col>
            <Col className="text-center">
              Pago: {code.totalPago().toFixed(2).replace(".", ",")}
            </Col>
            <Col className="text-end">
              Troco: {code.totalTroco().toFixed(2).replace(".", ",")}
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          {props.dataMeioPagamento.length > 0 && (
            <Button
              variant="outline-danger"
              size="sm"
              className="me-auto"
              onClick={code.onReiniciarPagamentos}
            >
              Reiniciar
            </Button>
          )}
          <Button
            variant="outline-primary"
            className="messagebox-btn-cancel"
            onClick={code.onHideClick}
          >
            Voltar
          </Button>
          {code.exibirValor ? (
            <Button type="submit" form="formPagamento">
              Confirmar
            </Button>
          ) : code.podeFinalizar() ? (
            <Button type="submit" form="formDestinatario">
              Finalizar
            </Button>
          ) : (
            <></>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};
